import { createAction } from '@reduxjs/toolkit';

const UPDATE_TEMPLATE = 'email-templates/UPDATE_TEMPLATE';
const RESET_TEMPLATE = 'email-templates/RESET_TEMPLATE';

export const updateTemplate = createAction(UPDATE_TEMPLATE);
export const resetTemplate = createAction(RESET_TEMPLATE);
